import { render, staticRenderFns } from "./HomeWishlistNL.vue?vue&type=template&id=9771e3d6&scoped=true"
import script from "./HomeWishlistNL.vue?vue&type=script&lang=js"
export * from "./HomeWishlistNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9771e3d6",
  null
  
)

export default component.exports